import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_staff/id-managements/group-id/$id/_$id/",
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/id-managements/group-id/$id/members",
      params: { id: params.id },
    });
  },
});
